---
en:
  downtime_events:
    auto_notice: Downtime periods does not account for optimization plan for power plants with reservoir
    available: Available
    capacity_impact: Capacity Impact
    chart_monthly_heading: Monthly downtime reasons
    chart_volume_heading: Production and downtime
    chart_yearly_heading: Yearly downtime reasons
    components:
      control_system: Control System
      external_grid: External Grid
      fiber_and_communication: Fiber And Communication
      foundation: Foundation
      generator: Generator
      hardstand: Hardstand
      high_voltage_system: High Voltage System
      intake: Intake
      internal_grid: Internal Grid
      inverter: Inverter
      logger: Logger
      module: Module
      other: Other
      pyranometer: Pyranometer
      road: Road
      string: String
      substation: Substation
      transformer: Transformer
      turbine: Turbine
      waterway: Waterway
    create: Create
    deletion_failed: Failed to delete downtime period
    downtime_event: Downtime period
    edit: Edit downtime period
    email:
      body:
        contact: Contact %{name} for more information
        info: A new downtime period has been scheduled. Please account for this in your operation of this power plant.
    email_to_operator: Send email to operator
    est_downtime_cost: Est. cost
    est_downtime_hours: Est. hours
    est_loss: Est. loss
    est_lost_prod_vol: Est. lost vol.
    est_revenue: Est. revenue
    est_vol_hr: Est. vol/hr
    filter_out_no_water: Filter out no water
    model_name: Downtime period
    model_name_plural: Downtime periods
    model_name_short: Downtime
    no-data-text: No data available - select a power plant
    no_hours: Hours affected
    no_match: Selected parameters do not match any power plant.
    not_specified: Not specified
    reasons:
      commercial_price: Commercial/Price
      effect_restriction: Effect restriction
      external_grid: External grid
      grid: Grid
      no_water: No water
      operational_loss: Operational loss
      overflow: Overflow
      planned_maintenance: Planned maintenance
      reservoir: Reservoir
      technical: Technical
      uncategorized: Uncategorized
      unplanned_maintenance: Unplanned maintenance
      water_loss: Water loss
      wind: Wind
    scheduled_downtime_event: Scheduled downtime period
    scheduled_downtime_events_name: Scheduled downtime periods
    scheduled_downtime_for: Scheduled downtime period for
    see_stats: Chose a power plant to see stats
    tab_downtime: Downtime Events
    tab_environmental_flow: Environmental flow events
    tech_downtime: Technical downtime
    tech_downtime_short: Tech downtime
    unavailable: Unavailable
    verified_event_cannot_be_deleted: Verified downtime periods cannot be deleted
    verified_event_change_confirmation: This downtime event has been verified. Changing it may affect reports and calculations. Do you want to proceed?
    water_level: Water level
    water_level_unit: m.a.s.l.
    water_loss_downtime: Water loss downtime
  environmental_flow:
    actions: Actions
    assign_to: Assign to
    avg_flow: Avg Flow
    avg_violation: Avg Violation
    comment: Description
    confirm_delete: Are you sure you want to delete this environmental flow event?
    confirm_run_detection: Run violation detection for the last 30 days? This may take a few minutes.
    corrective_volume: Volume (l/s) for corrective measure
    create_event: Create Environmental Flow Event
    current_image: Current image
    delete_error: Could not delete event. Verified events cannot be deleted.
    detection_job_error: Failed to start violation detection job. Please try again.
    detection_job_started: Violation detection job started. Results will appear shortly.
    duration: Duration
    ends_at: End Time
    event: environmental flow event
    event_created: Environmental flow event created successfully
    excluded: Excluded
    fetch_data_error: Failed to load environmental flow data. Please try again.
    fetch_drilldown_error: Failed to load drilldown data. Please try again.
    fetch_error: Failed to load environmental flow events. Please try again.
    fetch_events_error: Failed to load environmental flow events. Please try again.
    fetch_latest_value_error: Failed to load latest sensor value. Please try again.
    fetch_threshold_error: Failed to load threshold data. Please try again.
    further_corrective_measures: Further corrective measures
    generate_task: Generate task
    hide_excluded: Hide Excluded
    image: Image
    immediate_measures: Immediate measures
    linked_task: Linked task
    min_flow: Min Flow
    no_responsibles_available: No company responsibles available. Please configure at least one company responsible for this power plant.
    power_plant: Power Plant
    reporter_name: Name of reporter
    run_detection: Detect Violations
    show_excluded: Show Excluded
    starts_at: Start Time
    threshold: Threshold
    title: Environmental Flow Violations
    total_events: Total Events
    total_hours: Total Hours
    update_comment_error: Failed to update comment. Please try again.
    update_excluded_error: Failed to update excluded status. Please try again.
    update_further_corrective_measures_error: Failed to update further corrective measures. Please try again.
    update_immediate_measures_error: Failed to update immediate measures. Please try again.
    update_reporter_name_error: Failed to update reporter name. Please try again.
    update_verification_error: Failed to update verification status. Please try again.
    verified: Verified
    view_image: View image
    violation_pct: Violation %
